<template>
  <b-row>
    <b-col>
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading :module-id="Modules.FINANZAS" :profile-id="Profiles.PERSONAL" reference="cashDetail" summary-only />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }" v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'" @click="filtersOpen = !filtersOpen"><AppIcon name="filter" :fill="filtersOpen" /></b-button>
              <b-dropdown right no-caret size="sm" variant="link" boundary="window" toggle-class="list-view-icon-btn list-view-icon-btn--primary" :disabled="!filters.finances_cash" v-b-tooltip.hover.bottom title="Movimientos de caja" aria-label="Movimientos de caja">
                <template #button-content><AppIcon name="add" /></template>
                <b-dropdown-item @click="goTo('positive-adjustment')"><span class="cash-detail-movement-item"><span class="cash-detail-movement-icon cash-detail-movement-icon--positive"><AppIcon name="add" /></span> Ajuste positivo</span></b-dropdown-item>
                <b-dropdown-item @click="goTo('negative-adjustment')"><span class="cash-detail-movement-item"><span class="cash-detail-movement-icon cash-detail-movement-icon--negative"><AppIcon name="remove" /></span> Ajuste negativo</span></b-dropdown-item>
                <b-dropdown-item @click="goTo('transfer')"><span class="cash-detail-movement-item"><span class="cash-detail-movement-icon cash-detail-movement-icon--transfer"><AppIcon name="swap_horiz" /></span> Transferir</span></b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters" :key="keyForceUpdate">
            <div class="list-view-filter cash-detail-filter-findobject cash-detail-filter-cash"><FindObject render="search" type="cash" @select-object="loadCash($event)" :orWhere="conditionCashOr" :showAllRegister="true" :valueID="filters.finances_cash_id" /></div>
            <div class="list-view-filter"><label class="filter-label">Desde</label><b-form-input type="date" size="sm" v-model="filters.date_start" /></div>
            <div class="list-view-filter"><label class="filter-label">Hora desde</label><b-form-timepicker size="sm" now-button reset-button v-model="filters.time_start" locale="es" /></div>
            <div class="list-view-filter"><label class="filter-label">Hasta</label><b-form-input type="date" size="sm" v-model="filters.date_end" /></div>
            <div class="list-view-filter"><label class="filter-label">Hora hasta</label><b-form-timepicker size="sm" now-button reset-button v-model="filters.time_end" locale="es" /></div>
            <div class="list-view-filter cash-detail-filter-findobject cash-detail-filter-currency"><FindObject render="search" type="currency" auto-select-single @select-object="loadCurrency($event)" :valueID="filters.currency_id" :where="conditionCurrencyActive" /></div>
            <b-button variant="outline-dark" size="sm" @click="filterReport" v-b-tooltip.hover title="Aplicar filtros" style="height:31px;width:31px;padding:0;flex-shrink:0;"><AppIcon name="filter" /></b-button>
          </div>
        </b-collapse>
      </b-card>
      
      <b-card no-body class="cash-detail-movimientos" v-if="filters.finances_cash">
            <div class="cash-detail-context" v-if="filters.finances_cash.only_open">
              <div class="cash-detail-context__status">
                <span v-if="filters.finances_cash.opening" class="table-cash-status-open"><AppIcon name="lock_open" /> Caja abierta <small>(<span v-html="statusCash(filters.finances_cash)"></span>)</small></span>
                <span v-else class="table-cash-status-close"><AppIcon name="lock" /> Caja cerrada</span>
                <b-button @click="searchCash" type="button" variant="link" size="sm" class="list-view-ghost-btn cash-detail-context__refresh" v-b-tooltip.hover title="Actualizar estado y movimientos"><AppIcon name="refresh" class="mr-1" /> Actualizar</b-button>
              </div>
            </div>
            <b-table class="app-table m-0 p-0"
                    responsive
                    sticky-header="60vh"
                    :hover="true"
                    :stacked="isMobileViewport ? 'md' : false"
                    :fixed="!isMobileViewport"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    :items="table.items"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

              <template v-slot:table-colgroup="scope">
                <col
                  v-for="field in scope.fields"                    
                  :key="field.key"
                  :style="{ width: field.width }"
                >
              </template> 

              <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Cargando...</strong>
                </div>
              </template>

              <template v-slot:cell(date)="data">
                <div v-if="data.item.date_time">
                  {{ moment(data.item.date_time).format('DD MMMM YYYY') }}
                </div>
              </template>

              <template v-slot:cell(time)="data">
                <div v-if="data.item.date_time">
                  {{ moment(data.item.date_time).format('HH:mm') }}
                </div>
              </template>

              <template v-slot:cell(origen)="data">
                <span v-if="data.item.origen.customer"><b>CLIENTE:</b> {{data.item.origen.customer}}</span>
                <span v-if="data.item.origen.supplier"><b>PROVEEDOR:</b> {{data.item.origen.supplier}}</span>
              </template>

              <template v-slot:cell(observations)="data">
                <span v-if="data.item.origen.observations" class="cash-detail-origin-observations">{{ data.item.origen.observations }}</span>
              </template>

              <template v-slot:cell(reference)="data">                                                                                
                <div v-if="!Array.isArray(data.item.origen)" style="cursor: pointer;" v-b-tooltip.hover.bottom :title="data.item.reference">
                  <div v-if="data.item.origen.customer">                      
                    <div :id="'customer-extra-'+data.item.id">                    
                      {{data.item.reference}}
                    </div>
                    <b-popover :target="'customer-extra-'+data.item.id" triggers="hover" placement="top">
                      <template #title>Datos de Recibo</template>

                      <span v-if="data.item.origen.point_sale">
                        {{data.item.origen.types_vouchers}} <br>
                        {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                        <hr>
                        {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                        ({{data.item.origen.customer_id}}) - {{data.item.origen.customer}} 
                        <hr>
                        {{ data.item.origen.observations }}                      
                      </span>
                    </b-popover>                                      
                  </div>
                  
                  <div v-if="data.item.origen.supplier">
                    <div :id="'supplier-extra-'+data.item.id">                    
                      {{data.item.reference}}
                    </div>
                    <b-popover :target="'supplier-extra-'+data.item.id" triggers="hover" placement="top">
                      <template #title>Datos de Pago</template>                    

                      <span v-if="data.item.origen.point_sale">
                        {{data.item.origen.types_vouchers}} <br>
                        {{data.item.origen.point_sale.toString().padStart(4,'0') + '-' + data.item.origen.number.toString().padStart(8,'0')}} 
                        <hr>
                        {{moment(data.item.origen.date).format('DD MMMM YYYY')}} <br>
                        ({{data.item.origen.supplier_id}}) - {{data.item.origen.supplier}} 
                        <hr>
                        {{ data.item.origen.observations }}
                      </span>
                    </b-popover> 
                  </div>                  
                </div>    
                <div v-else v-b-tooltip.hover.bottom :title="data.item.reference">
                  {{data.item.reference}}
                </div>            
              </template>

              <template v-slot:cell(amount)="data">
                <span v-if="data.item.type_balance=='+'" class="cash-detail-text-success">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount)}}
                </span>
                <span v-if="data.item.type_balance=='-'" class="cash-detail-text-danger">
                  ({{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount)}})
                </span>
              </template>

              <template v-slot:cell(f_action)="data">
                <b-dropdown right no-caret size="sm" variant="link" boundary="window" :toggle-class="isMobileViewport ? 'cash-detail-action-toggle-labeled' : 'app-table-action-toggle'" :class="{ 'pull-right': !isMobileViewport }" v-if="data.item.manual">
                  <template #button-content><AppIcon name="more_vert" :class="{ 'mr-1': isMobileViewport }" /><span v-if="isMobileViewport">Opciones</span></template>
                  <b-dropdown-item @click="remove(data.item)">
                    <AppIcon name="delete" class="mr-1" /> Eliminar
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
            <EmptyState v-else icon="receipt_long" title="No se encontraron movimientos" />
            <div class="app-table-footer cash-detail-table-footer" v-if="table.items.length">
              <span>{{ table.tablePaginate ? table.tablePaginate.total : table.items.length }} registros</span>
              <export-excel class="list-view-link" :data="arr.export" worksheet="Listado de movimientos de caja/cuenta" name="list-cash.xls"><AppIcon name="download" class="mr-1" /> Exportar</export-excel>
            </div>
      </b-card>

      <div ref="totalsAnchor" class="cash-detail-totals-anchor" v-if="table.items.length && filters.finances_cash"></div>

      <b-row align-h="end" v-if="table.items.length && filters.finances_cash && !totalsFloating" :key="'inline_'+keyForceUpdate">
        <b-col sm="4">      
          <b-card no-body class="cash-detail-totales">
            <b-table-simple hover responsive class="app-table m-0">
              <b-thead>
                <b-tr>                      
                  <b-th width="30%" class="text-right">
                    <div class="mr-1">Moneda</div>                        
                  </b-th>
                  <b-th width="35%" class="text-right">
                    <div class="mr-1">Total</div>
                  </b-th>                                
                  <b-th width="35%" class="text-right">
                    <div class="mr-1">Resumen</div>                        
                  </b-th>                                    
                </b-tr>
              </b-thead>  
              <b-tbody> 
                <b-tr v-for="(element, index) in this.getTotalByCurrency()" :key="'inline_'+index">                                       
                  <b-td class="text-right align-middle">        
                    <div class="mr-1">
                      <b>{{element.currency_name}}</b>
                    </div>            
                  </b-td>                  
                  <b-td class="text-right align-middle cash-detail-amount-totals">   
                    <div class="mr-1" v-if="filters.finances_cash" :class="{'cash-detail-text-danger':parseFloat(getTotalCash(element.currency_id))<0, 'cash-detail-text-success':parseFloat(getTotalCash(element.currency_id))>=0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( getTotalCash(element.currency_id) )}}
                    </div>            
                  </b-td>
                  <b-td class="text-right align-middle">        
                    <div class="mr-1 cash-detail-amount-totals" :class="{'cash-detail-text-danger':parseFloat(element.currency_amount)<0, 'cash-detail-text-success':parseFloat(element.currency_amount)>=0}">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( element.currency_amount )}}
                    </div>            
                  </b-td>                                    
                </b-tr>
              </b-tbody>
            </b-table-simple>            
          </b-card>
        </b-col>
      </b-row>

      <div class="cash-detail-totals-floating" v-if="table.items.length && filters.finances_cash && totalsFloating">
        <b-card no-body class="cash-detail-totales">
          <b-table-simple hover responsive class="app-table m-0">
            <b-thead>
              <b-tr>                      
                <b-th width="30%" class="text-right">
                  <div class="mr-1">Moneda</div>                        
                </b-th>
                <b-th width="35%" class="text-right">
                  <div class="mr-1">Total</div>
                </b-th>                                
                <b-th width="35%" class="text-right">
                  <div class="mr-1">Resumen</div>                        
                </b-th>                                    
              </b-tr>
            </b-thead>  
            <b-tbody> 
              <b-tr v-for="(element, index) in this.getTotalByCurrency()" :key="'fixed_'+index">                                       
                <b-td class="text-right align-middle">        
                  <div class="mr-1">
                    <b>{{element.currency_name}}</b>
                  </div>            
                </b-td>                  
                <b-td class="text-right align-middle cash-detail-amount-totals">   
                  <div class="mr-1" v-if="filters.finances_cash" :class="{'cash-detail-text-danger':parseFloat(getTotalCash(element.currency_id))<0, 'cash-detail-text-success':parseFloat(getTotalCash(element.currency_id))>=0}">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( getTotalCash(element.currency_id) )}}
                  </div>            
                </b-td>
                <b-td class="text-right align-middle">        
                  <div class="mr-1 cash-detail-amount-totals" :class="{'cash-detail-text-danger':parseFloat(element.currency_amount)<0, 'cash-detail-text-success':parseFloat(element.currency_amount)>=0}">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:element.currency_code}).format( element.currency_amount )}}
                  </div>            
                </b-td>                                    
              </b-tr>
            </b-tbody>
          </b-table-simple>            
        </b-card>
      </div>
      
      <b-card body-class="py-2" class="cash-detail-page-footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="back" class="mr-1" />
              Volver
            </b-button>                        
          </b-col>
      
          <b-col>
            <nav v-if="table.tablePaginate">
              <b-pagination class="pull-right mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterReport()" />
            </nav>
          </b-col>  
        </b-row>
      </b-card>


      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              size="lg"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <template #modal-header>
          <div class="app-modal-header">
            <span class="app-modal-header__icon"><AppIcon :name="crud.form.event == 'transfer' ? 'swap_horiz' : (crud.form.type_balance == '-' ? 'remove' : 'add')" /></span>
            <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
          </div>
        </template>

        <b-row>                     
          <b-col sm="12">
            <FindObject render="search"
                        type="cash"    
                        tag="Origen"                     
                        @select-object="loadCashOrigin($event)"
                        :valueID="crud.form.finances_cash_id"
                        :showAllRegister="true"
                        :where="conditionCash"
                        :disabled="!selectOriginForMovement"/>
          </b-col>

          <b-col sm="12" v-if="crud.form.event == 'transfer'">
            <FindObject render="search"
                        type="cash"                      
                        tag="Destino"                        
                        @select-object="loadCashTransfer($event)"                                                 
                        :valueID="crud.form.finances_cash_transfer_id"
                        :showAllRegister="true"
                        :key="keyForceUpdateCashTransfer"
                        :where="conditionCash"/>
          </b-col>          

          <b-col md="6">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm"  
                                 v-model="crud.form.date" 
                                 placeholder="Fecha" 
                                 local="es">
              </b-form-datepicker>             
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Hora">
              <b-form-timepicker size="sm" 
                                 v-model="crud.form.time"  
                                 now-button 
                                 reset-button 
                                 locale="es">
              </b-form-timepicker>         
            </b-form-group>
          </b-col>
        
          <b-col md="8">
            <div v-if="crud.form.event == 'adjustment'" class="cash-detail-modal-notice" :class="crud.form.type_balance == '-' ? 'cash-detail-modal-notice--negative' : 'cash-detail-modal-notice--positive'">
              <span class="cash-detail-modal-notice__icon"><AppIcon :name="crud.form.type_balance == '-' ? 'remove' : 'add'" /></span>
              <div><strong>{{ crud.form.type_balance == '-' ? 'Movimiento de egreso' : 'Movimiento de ingreso' }}</strong><span>El importe se registrará con saldo {{ crud.form.type_balance == '-' ? 'negativo' : 'positivo' }}.</span></div>
            </div>
            <div v-if="crud.form.event == 'transfer'" class="cash-detail-modal-notice cash-detail-modal-notice--transfer">
              <span class="cash-detail-modal-notice__icon"><AppIcon name="swap_horiz" /></span>
              <div><strong>Transferencia entre cajas</strong><span>Se genera una salida en origen y una entrada en destino.</span></div>
            </div>
          </b-col>
          <b-col md="4">
            <b-form-group label="Importe">
              <b-input-group prepend="$">            
                <app-number-input v-model="crud.form.amount" />
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group label="Referencia">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.reference"
                            required
                            placeholder="Ingresar una referencia">
              </b-form-input>
            </b-form-group>
          </b-col>          
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false"><AppIcon name="x" class="mr-1" /> Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>      

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import Storage from '@/handler/storageLocal'
  import Vue from 'vue'
  import FindObject from '@/components/inc/find/findObject' 
  import ModuleViewHeading from '@/components/inc/module/ModuleViewHeading'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      ModuleViewHeading,
      TabHeaderActions,
    }, 
    data: () => {
      return {      
        Modules,
        Profiles,
        access: {
          module_id: Modules.FINANZAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'cashDetail',
          elements: {}
        }, 
        table : {
          items: [],
          filters: null,
          fields: [],
          currentPage: 1,
          perPage: 0,
          tablePaginate: null,
          isBusy: false,
        },          
        arr: {
          export: [],
        },
        filters: {
          finances_cash: null,
          finances_cash_id: 0,
          finances_cash_transfer: null,
          finances_cash_transfer_id: 0,
          currency: null,
          currency_id: 0,
          date_start: '',
          time_start: '',
          date_end: '',
          time_end: '',
        }, 
        crud: {
          form: {            
            finances_cash_id: 0,
            finances_cash: null,            
            currency_id: 0,
            currency: null,
            date: '',
            time: '',
            reference: '',
            amount: 0,
            manual: true,
            event: 'adjustment'
          },                 
        },        
        modal: {
          form: {
            active: false,
            title: ''
          },        
        },         
        object: {
          staff: null
        },        
        keyForceUpdate: 0,   
        keyForceUpdateCashTransfer: 0,   
        totalsFloating: false,
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
        selectOriginForMovement: false,
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },  
    computed: {
      // WHERE SELECT
      conditionCurrencyActive(){
        let condition = []
        condition.push({field: 'status', condition: true})
        return condition
      },
      conditionCash(){
        let condition = []
        condition.push({field: 'active', condition: true})
        return condition
      },       
      conditionCashOr() {        
        var arrWhere = []          
        if(this.object.staff && this.object.staff.cash_id) {
          arrWhere.push({field: 'id', condition: this.object.staff.cash_id})
          arrWhere.push({field: 'shared', condition: true})     
        } 
        return arrWhere;
      }, 
    },
    mounted() {      
      this.filtersOpen = Storage.getValue('filters_open_cash_detail') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.loadFieldTable()
      this.showStaff()
      window.addEventListener('scroll', this.refreshTotalsPosition, { passive: true })
      window.addEventListener('resize', this.refreshTotalsPosition)

      this._start = true
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      } 

      this.showStaff()
      window.addEventListener('scroll', this.refreshTotalsPosition, { passive: true })
      window.addEventListener('resize', this.refreshTotalsPosition)
      this.refreshTotalsPosition()
    },
    deactivated() {
      window.removeEventListener('scroll', this.refreshTotalsPosition)
      window.removeEventListener('resize', this.refreshTotalsPosition)
    },
    beforeDestroy() {
      if(this.mobileMql) this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      window.removeEventListener('scroll', this.refreshTotalsPosition)
      window.removeEventListener('resize', this.refreshTotalsPosition)
    },       
    watch: {
      filtersOpen(value) {
        Storage.setValue('filters_open_cash_detail', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      }
    },
    methods: {
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      loadFieldTable() {
        this.table.fields = [
          {key: 'id', label: 'ID', class: 'align-middle', width:'5%'},
          {key: 'date', label: 'Fecha', class: 'align-middle', width:'10%'},
          {key: 'time', label: 'Hora', class: 'align-middle', width:'5%'},
          {key: 'reference', label: 'Referencia', class: 'align-middle cash-detail-cell-wrap', width:'30%'},
          {key: 'origen', label: 'Origen', class: 'align-middle cash-detail-cell-wrap', width:'15%'},
          {key: 'observations', label: 'Observaciones', class: 'align-middle cash-detail-cell-wrap', width:'15%'},
          {key: 'amount', label: 'Importe', class: 'align-middle ' + this.alignClass('text-right'), width:'18%'},
          {key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle', width:'2%'},
        ]
      },
      showStaff()  {
        let staffID = Helper.getStaffId()
        var result = serviceAPI.mostrarStaff(staffID)

        result.then((response) => {
          var data = response.data
          if(data) {
            this.object.staff = data
          } else {
            this.object.staff = null
          } 
          
          this.searchCash()
        })          
      },           
      searchCash() {                
        var result = serviceAPI.obtenerCajas()

        result.then((response) => {
          var data = response.data

          if(data.length) {     
            this.filters.finances_cash = data[0]
            this.filters.finances_cash_id = data[0].id
          }    

          this.filterLoad()      
          this.restoreFilterStorage() 

          this.forceUpdate()                    
          this.consumeQuickAction()
          //this.filterReport()          
        })                  
      },      
      filterLoad() { 
        this.filters.date_start = moment().format('YYYY-MM-DD')  
        this.filters.time_start = null  
        this.filters.date_end = moment().format('YYYY-MM-DD') 
        this.filters.time_end = null  
      },
      loadCash (object) {        
        if(object){
          this.filters.finances_cash = object
          this.filters.finances_cash_id = object.id    
          
          this.filterReport()
        } else {
          this.filters.finances_cash = null
          this.filters.finances_cash_id = 0
          this.table.items = []
          this.totalsFloating = false
        }
      }, 
      loadCurrency (object) {        
        if(object){
          this.filters.currency = object
          this.filters.currency_id = object.id        
        } else {
          this.filters.currency = null
          this.filters.currency_id = 0
        }
      }, 
      filterReport(){
        this.saveFilterStorage()     

        if(!this.filters.finances_cash_id) {
          this.$awn.alert("Debe seleccionar una caja/cuenta");
          return false;
        }

        this.table.isBusy = true
        var result = serviceAPI.filtrarCajaDetalle(this.filters, this.table.currentPage)        

        result.then((response) => {
          this.table.isBusy = false
          this.table.items = response.data.data
          this.table.tablePaginate = response.data

          this.prepareExport(response.data.data)
          this.refreshTotalsPosition()
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      }, 
      refreshTotalsPosition() {
        this.$nextTick(() => {
          if(!this.table.items.length || !this.filters.finances_cash) {
            this.totalsFloating = false
            return
          }

          let anchor = this.$refs.totalsAnchor
          if(Array.isArray(anchor)) {
            anchor = anchor[0]
          }
          if(anchor && anchor.$el) {
            anchor = anchor.$el
          }

          if(!anchor || !anchor.getBoundingClientRect) {
            this.totalsFloating = false
            return
          }

          this.totalsFloating = anchor.getBoundingClientRect().top > (window.innerHeight - 20)
        })
      },

      getTotalByCurrency() {        
        var arrTotal = []

        if(this.table.items.length) {
          this.table.items.forEach(element=>{
            var code = element.currency.id     
            arrTotal[code] = null
            
            arrTotal[code] = {
              currency_id: element.currency.id,
              currency_name: element.currency.name,
              currency_code: element.currency.code,
              currency_amount: 0,
            }
          })          
        }
        
        this.table.items.forEach(element=>{                 
          var code = element.currency.id          

          if(element.type_balance == '+') {
            arrTotal[code].currency_amount = parseFloat(arrTotal[code].currency_amount) + parseFloat(element.amount)
          } else {
           arrTotal[code].currency_amount = parseFloat(arrTotal[code].currency_amount) - parseFloat(element.amount) 
          }          
        })

        arrTotal = arrTotal.filter((obj) => { return ![null, undefined].includes(obj) })

        return arrTotal        
      },
      getTotalCash($currency_id) {        
        var total = 0
        if(this.filters.finances_cash) {
          this.filters.finances_cash.total_available.forEach(element => {
            if(element.currency_id == $currency_id) {
              total = element.amount
            }            
          }); 
        }
        return total
      },

      forceUpdate() {
        this.keyForceUpdate = this.keyForceUpdate + 1
      },          
      forceUpdateCashTransfer() {
        this.keyForceUpdateCashTransfer = this.keyForceUpdateCashTransfer + 1
      },                

      goTo(data) {
        switch (data) {
          case 'positive-adjustment':
            this.addAdjustment('+')
            break;
        
          case 'negative-adjustment':
            this.addAdjustment('-')
            break;
            
          case 'transfer':
            this.addTransfer()
            break;                      
        }
      },
      consumeQuickAction() {
        if (this.$route.query.new != '1') return

        var mode = this.$route.query.mode
        if (mode == 'cash-income') this.addAdjustment('+', true)
        else if (mode == 'cash-expense') this.addAdjustment('-', true)
        else if (mode == 'cash-transfer') this.addTransfer(true)
        else return

        this.$router.replace({ name: 'FinancesStaffCashDetail' }).catch(() => {})
      },
      addAdjustment(type_balance, selectOrigin = false) {
        let title = "Ajuste Positivo"
        if(type_balance == '-') {
          title = "Ajuste Negativo"
        }

        this.crud.form.event = 'adjustment'       
        this.selectOriginForMovement = selectOrigin
        this.crud.form.finances_cash_id = selectOrigin ? 0 : this.filters.finances_cash_id
        this.crud.form.finances_cash = selectOrigin ? null : this.filters.finances_cash
        this.crud.form.currency_id = 1
        this.crud.form.currency = null
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.time = ''
        this.crud.form.reference = ''
        this.crud.form.amount = 0
        this.crud.form.type_balance = type_balance

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = title
        this.modal.form.active = true
      },   
      addTransfer(selectOrigin = false) {
        this.crud.form.event = 'transfer'       
        this.selectOriginForMovement = selectOrigin
        this.crud.form.finances_cash_id = selectOrigin ? 0 : this.filters.finances_cash_id
        this.crud.form.finances_cash = selectOrigin ? null : this.filters.finances_cash
        this.crud.form.finances_cash_transfer_id = 0
        this.crud.form.finances_cash_transfer = null        
        this.crud.form.currency_id = 1
        this.crud.form.currency = null
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.time = ''
        this.crud.form.reference = ''
        this.crud.form.amount = 0         
        this.crud.form.type_balance = "-"

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Transferencia"
        this.modal.form.active = true
      },   

      loadCashTransfer (object) {        
        if(object){          
          this.crud.form.finances_cash_transfer = object
          this.crud.form.finances_cash_transfer_id = object.id    

          if(this.crud.form.finances_cash_transfer_id == this.crud.form.finances_cash_id) {
            this.crud.form.finances_cash_transfer = null
            this.crud.form.finances_cash_transfer_id = 0
            this.forceUpdateCashTransfer()

            this.$awn.info("La caja/cuenta origen debe ser distina a la de destino");
            return false
          } 
        } else {
          this.crud.form.finances_cash_transfer = null
          this.crud.form.finances_cash_transfer_id = 0
        }
      },
      loadCashOrigin(object) {
        this.crud.form.finances_cash = object || null
        this.crud.form.finances_cash_id = object ? object.id : 0

        if (this.crud.form.finances_cash_transfer_id == this.crud.form.finances_cash_id) {
          this.crud.form.finances_cash_transfer = null
          this.crud.form.finances_cash_transfer_id = 0
          this.forceUpdateCashTransfer()
        }
      },

      save() {
        if(!this.crud.form.finances_cash_id) {
          this.$awn.warning("Seleccioná la caja/cuenta de origen")
          return false
        }

        if(this.crud.form.event == 'transfer' && !this.crud.form.finances_cash_transfer_id) {
          this.$awn.warning("Seleccioná la caja/cuenta de destino")
          return false
        }
        if(!this.crud.form.reference) {
          this.$awn.warning("Ingresá una referencia");
          return false
        }

        if(parseFloat(this.crud.form.amount)<0) {
          this.$awn.warning("Ingresá una importe mayor a cero (0)");
          return false
        }        

        let loader = this.$loading.show();

        var result = serviceAPI.agregarCajaDetalle(this.crud.form);
        
        result.then((response) => {
          this.modal.form.active = false
          loader.hide()

          this.forceUpdate()                    
          this.filterReport()

          this.$awn.success("Ajuste guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      remove(item) {        
        this.$bvModal.msgBoxConfirm('¿Desea borrar el ajuste (' + item.reference + ')?', {
          title: 'Borrar Ajuste',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCajaDetalle(item.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()

              this.forceUpdate()                    
              this.filterReport()

              this.$awn.success("Ajuste eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_cash_details', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {                        
        if(Storage.getValue('filter_cash_details')) {
          this.filters = JSON.parse(Storage.getValue('filter_cash_details'))
        }         

        let finances_cash_id = this.$route.params.finances_cash_id        
        let date_start = this.$route.params.date_start        
        if(finances_cash_id) {
          this.filters.finances_cash_id = finances_cash_id
          this.filters.date_start = moment(date_start).format('YYYY-MM-DD')
          this.filters.time_start = moment(date_start).format('HH:mm')          
        }
      },    
      prepareExport(data) {        
        this.arr.export = []

        data.forEach(element => {
          var amount = element.amount
          
          if(element.type_balance == '-'){
              amount = element.type_balance + amount
          }

          this.arr.export.push({
            id: element.id,
            date: moment(element.date_time).format('YYYY-MM-DD'),
            time: moment(element.date_time).format('HH:mm'),
            reference: element.reference,
            origen: element.origen.customer ? "CLIENTE: " + element.origen.customer : element.origen.supplier ? "PROVEEDOR: " + element.origen.supplier : '',            
            amount: amount.replace('.',','),
          })
        });        
      },

      statusCash(data) {
        let status = ''
        
        if(data.status.status == 'OPEN') {
          if(data.status.open) {
            status = moment(data.status.open).locale('es').fromNow()
          } else {
            status = moment().locale('es').fromNow()
          }
          
        }

        return status       
      }      
    }    
  }
</script>
<style>
  .cash-detail-filter-findobject .form-group { margin-bottom: 0; }
  .cash-detail-filter-findobject legend,
  .cash-detail-filter-findobject label { border: 0; color: var(--app-color-text-secondary); display: block; float: none; font-size: 11px; font-weight: var(--app-font-semibold); line-height: normal; margin-bottom: 2px; padding: 0; width: auto; }
  /* La tabla usa anchos fijos: estas tres columnas continúan en varias
     líneas al alcanzar su límite, en vez de truncarse. */
  .cash-detail-movimientos .app-table td.cash-detail-cell-wrap {
    overflow: visible !important;
    overflow-wrap: anywhere !important;
    text-overflow: clip !important;
    white-space: normal !important;
  }
  .cash-detail-movimientos .app-table td.cash-detail-cell-wrap > * {
    overflow-wrap: anywhere !important;
    white-space: normal !important;
  }
  @media (min-width: 768px) {
    /* Las filas sin menú de acciones conservan el alto mínimo de aquellas que
       sí contienen el botón de tres puntos; el contenido multilínea puede
       ampliar la fila normalmente. En mobile la tabla se apila y no se debe
       fijar el alto de la fila. */
    .cash-detail-movimientos .app-table tbody tr { height: 34px; }
  }
</style>
<style scoped>
  .cash-detail-amount-totals {
    font-size: 15px;
    color: var(--app-color-success);
    font-weight: 800;
  }
  .cash-detail-text-success {
    color: var(--app-color-success);
  }
  .cash-detail-text-danger {
    color: var(--app-color-danger);
  }
  .cash-detail-origin-observations { color: var(--app-color-text-secondary); display: block; line-height: 1.35; margin-top: 3px; overflow-wrap: anywhere; }

  .cash-detail-filter-cash { flex: 1 1 250px; max-width: 320px; }
  .cash-detail-filter-currency { flex: 1 1 190px; max-width: 260px; }
  .cash-detail-movement-item { align-items: center; color: var(--app-color-text); display: inline-flex; font-size: var(--app-text-sm); gap: 8px; }
  .cash-detail-movement-icon { align-items: center; border-radius: 50%; display: inline-flex; height: 22px; justify-content: center; width: 22px; }
  .cash-detail-movement-icon .material-symbols-rounded { font-size: 15px; }
  .cash-detail-movement-icon--positive { background: var(--app-color-success-soft); color: var(--app-color-success); }
  .cash-detail-movement-icon--negative { background: var(--app-color-danger-soft); color: var(--app-color-danger); }
  .cash-detail-movement-icon--transfer { background: var(--app-color-primary-soft); color: var(--app-color-primary); }
  .cash-detail-context { background: var(--app-color-surface); border-bottom: 1px solid var(--app-color-border); box-shadow: inset 3px 0 0 var(--app-color-text-muted); padding: 7px 12px; }
  .cash-detail-context__status { align-items: center; color: var(--app-color-text-secondary); display: flex; flex-wrap: wrap; font-size: var(--app-text-sm); gap: 10px; min-height: 31px; }
  .cash-detail-context__refresh { margin-left: auto; }
  .cash-detail-table-footer { padding-right: 12px; }
  .cash-detail-page-footer { background: var(--app-color-surface); border: 1px solid var(--app-color-border-strong); box-shadow: 0 -3px 12px rgba(7, 58, 78, 0.13), 0 6px 16px rgba(7, 58, 78, 0.11); }
  .btn.cash-detail-action-toggle-labeled { align-items: center; background: transparent !important; border: none !important; box-shadow: none !important; color: var(--app-color-text-secondary) !important; display: inline-flex !important; font-size: var(--app-text-sm); height: auto !important; justify-content: flex-start; min-height: 0; padding: 0 !important; width: auto !important; }
  .cash-detail-action-toggle-labeled.btn:hover,
  .cash-detail-action-toggle-labeled.btn:focus { color: var(--app-color-primary-hover); text-decoration: underline; }
  .cash-detail-totals-anchor {
    height: 0;
  }
  .cash-detail-totals-floating {
    position: fixed;
    right: 10px;
    bottom: 10px;
    width: 420px;
    max-width: calc(100vw - 20px);
    z-index: 1000;
  }
  .cash-detail-totals-floating .card {
    border: 1px solid var(--app-color-info-border);
    box-shadow: 0 12px 30px rgba(7, 58, 78, 0.26), 0 2px 7px rgba(7, 58, 78, 0.14);
    overflow: hidden;
  }
  .table-cash-status-open {
    align-items: center;
    color: var(--app-color-success);
    display: inline-flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    gap: 5px;
  }
  .table-cash-status-close {
    align-items: center;
    color: var(--app-color-text-secondary);
    display: inline-flex;
    font-size: var(--app-text-sm);
    font-weight: var(--app-font-semibold);
    gap: 5px;
  }
  .cash-detail-modal-notice { align-items: center; border: 1px solid; border-radius: 8px; display: flex; gap: 10px; min-height: 72px; padding: 12px; }
  .cash-detail-modal-notice__icon { align-items: center; border-radius: 50%; display: inline-flex; flex: 0 0 32px; height: 32px; justify-content: center; }
  .cash-detail-modal-notice__icon .material-symbols-rounded { font-size: 19px; }
  .cash-detail-modal-notice strong { color: var(--app-color-text); font-size: var(--app-text-sm); margin-bottom: 2px; }
  .cash-detail-modal-notice div > span { color: var(--app-color-text-secondary); display: block; font-size: var(--app-text-sm); }
  .cash-detail-modal-notice--positive { background: var(--app-color-success-soft); border-color: var(--app-color-success-border); }
  .cash-detail-modal-notice--positive .cash-detail-modal-notice__icon { background: var(--app-color-surface); color: var(--app-color-success); }
  .cash-detail-modal-notice--negative { background: var(--app-color-danger-soft); border-color: var(--app-color-danger-border); }
  .cash-detail-modal-notice--negative .cash-detail-modal-notice__icon { background: var(--app-color-surface); color: var(--app-color-danger); }
  .cash-detail-modal-notice--transfer { background: var(--app-color-info-soft); border-color: var(--app-color-info-border); }
  .cash-detail-modal-notice--transfer .cash-detail-modal-notice__icon { background: var(--app-color-surface); color: var(--app-color-info); }
  @media (max-width: 575.98px) {
    .cash-detail-context__refresh { margin-left: 0; }
  }
</style>
